import {
  Component,
  ElementRef,
  input,
  InputSignal,
  signal,
  ViewChild,
  WritableSignal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'aw-searchable-header',
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './searchable-header.component.html',
})
export class SearchableHeaderComponent {
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly control: InputSignal<FormControl<string>> =
    input.required<FormControl<string>>();

  @ViewChild('searchInput') searchInput?: ElementRef<HTMLInputElement>;

  protected readonly isSearchVisible: WritableSignal<boolean> = signal(false);

  protected toggleSearch(event: MouseEvent): void {
    event.stopPropagation();
    this.isSearchVisible.set(true);
    this.searchInput?.nativeElement.focus();
  }

  protected onBlur(): void {
    this.isSearchVisible.set(false);
  }
}
